import { createAction } from '@reduxjs/toolkit';

const setBookingFormInitialValues = createAction('booking/setInitialValues');
const saveBookingFormSubmittedValues = createAction(
  'booking/saveBookingFormSubmittedValues'
);
const saveExtraPicksSubmittedValues = createAction(
  'booking/saveExtraPicksSubmittedValues'
);
const setActiveBookingStep = createAction('booking/setActiveBookingStep');

const recordOffCanvasOpened = createAction('flow/offCanvasOpened');

export {
  setActiveBookingStep,
  setBookingFormInitialValues,
  saveBookingFormSubmittedValues,
  saveExtraPicksSubmittedValues,
  recordOffCanvasOpened,
};
